module.exports = __webpack_public_path__ + "static/3-5da831bcb70aeb4e43e5dc0b19dfc57a.jpg";